import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "cms-banner",
  name: "Banner轮播",
  icon: "播",
  group: "CMS通用",
  description: "展示置顶/推荐文章的大图轮播 Banner。",
  defaultProps: {
    "autoplay": true,
    "interval": 4000,
    "circular": true,
    "showTitle": true,
    "showIndicator": true,
    "pageSize": 5
}
}
